import { Box, Grid, Typography, Link, Divider } from "@mui/material";
import dayjs from "dayjs";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#4a3728",
        color: "#f5e6c8",
        mt: 4,
        borderTop: "3px solid #d4b483",
      }}
    >
      <Box sx={{ p: 4, maxWidth: 1200, mx: "auto" }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontFamily: '"Cinzel", serif', color: "#d4b483" }}
            >
              Whispering Sand
            </Typography>
            <Typography variant="body2" sx={{ color: "#c0b499" }}>
              Passionate Australian Shepherd breeding with love, selection, and
              dedication to the breed.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ color: "#d4b483", fontWeight: 600 }}
            >
              Navigation
            </Typography>
            <Link
              href="/"
              color="inherit"
              underline="hover"
              display="block"
              sx={{ color: "#f5e6c8", mb: 0.5 }}
            >
              News
            </Link>
            <Link
              href="/dogs"
              color="inherit"
              underline="hover"
              display="block"
              sx={{ color: "#f5e6c8", mb: 0.5 }}
            >
              Our Dogs
            </Link>
            <Link
              href="/puppies"
              color="inherit"
              underline="hover"
              display="block"
              sx={{ color: "#f5e6c8", mb: 0.5 }}
            >
              Puppies
            </Link>
            <Link
              href="/contacts"
              color="inherit"
              underline="hover"
              display="block"
              sx={{ color: "#f5e6c8", mb: 0.5 }}
            >
              Contacts
            </Link>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: "#6b5b4a" }} />

        <Typography variant="body2" align="center" sx={{ color: "#8a7a68" }}>
          © {dayjs().year()} Whispering Sand. All rights reserved.
        </Typography>
        <Typography
          variant="caption"
          align="center"
          display="block"
          sx={{ color: "#6b5b4a", mt: 1 }}
        >
          All texts and images are the exclusive property of this site —
          Reproduction Prohibited
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
